import { FlexProps, ColorContext, Rows } from '../atoms'
import { useContext } from 'react'
import React from 'react'

export const Panel = (props: FlexProps) => {
  const { bg } = useContext(ColorContext)
  return <Rows alignItems="flex-start" bg={bg} padding={1} {...props} />
}
